<template>
    <div class="steps">
        <div 
            @click.prevent="item.to && $router.push(item.to)" 
            class="step-item" 
            v-for="(item, index) in items" 
            :key="`step-${index}`" 
            :class="{active: index === value, 'has-link' : !!item.to}">
            <span class="step-item-number">{{ index + 1 }} </span>
            <span>{{ typeof(item) === 'string' ? item : item.title }}</span>
        </div>
    </div>
</template>


<script>
export default {
    name: 'steps',

    props: [
        'items',
        'value'
    ]
}
</script>

<style lang="scss" scoped>
.steps{

    display: flex;
    margin-bottom: 15px;

    .step-item{
        flex: 1;
        padding: 10px;
        font-size: 20px;
        // color: #666;
        background-color: #fff;
        display: flex;
        align-items: center;
        border-radius: 4px;
        margin-right: 15px;
        // box-shadow: 0 2px 2px #777;
        box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);

        &.has-link{
            cursor: pointer !important;
        }

        .step-item-number{
            width: 40px;
            height: 40px;
            background-color: var(--color-primary);
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 30px;
            font-weight: bold;
            margin-right: 5px;
        }

        &:last-child{
            margin-right: 0;
        }

        &.active{
            background-color: var(--color-primary);
            color: #fff;

            .step-item-number{
                background-color: #fff;
                color: var(--color-primary);

            }
        }



    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Steps.vue